module.exports = __webpack_public_path__ + "static/media/picture5@2x.dfca9ed0.png";